import React from "react";
import { connect } from "react-redux";
import { callService } from "../tools";

const mapState = (state) => {
	return {
		familiar : state.af.familiar,
		uid: state.global.uid,
		tid: state.global.tid,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
		alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje" : sMensaje });
		},
		pasoInvitado: (paso) => {
			dispatch({ "type": "AF_EDITAR_PASO", "paso": paso });
		},
		addEvento: (evento) => {
			dispatch({ "type": "AF_SET_EVENT", "evento": evento});
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

class GestionarEliminar extends React.Component {

	volver = () => {
		// GOOGLE TAG MANAGER //
		this.props.tagManager({ "type": "EVENT_ACCESOFAMILIAR_ELIMINAR-CANCELAR", "dispositivo": this.props.dispositivo });
		
		this.props.pasoInvitado(0);
		this.props.addEvento("BtnCancelar-EliminarInvitado");
	}

	eliminar = () => {
		let $this = this;
		$this.props.loader(true);
		this.props.addEvento("BtnEliminar-EliminarInvitado");
		let llamaServicio = new callService({
			service: "accesoFamiliar.eliminarFamiliar",
			secure: true,
			data: {
				familiar: this.props.familiar.id
			}
		}).execute().then((respuesta) => {
			// GOOGLE TAG MANAGER //
			$this.props.tagManager({ "type": "EVENT_ACCESOFAMILIAR_ELIMINAR-GUARDAR", "dispositivo": $this.props.dispositivo });
		
			console.log("Respuesta", respuesta);
			$this.props.loader(false);
			$this.props.pasoInvitado(4);
		}).catch((error) => {
			console.log("error", error);
			$this.props.loader(false);
			$("#modal-gestionar").modal("toggle");
			$this.props.alerta(error.message.mensaje);
		});
	}

	render() {
		return (
			<div>
				<h5><i><img src={ require("../img/icon-delete.png") } /></i>Eliminar invitado</h5>
				<hr className="mt-34" />
				<div className="row">
					<div className="col-xs-12 mb-20">
						<div className="texto-17 blue-text">
							<p>¿Estás seguro que deseas eliminar a {this.props.familiar.nombre} como tu invitado?. Ya no podrá visualizar tus pólizas compartidas.</p>
						</div>
						<div className="text-center aceptar-cancelar-btn mt-75">
							<a onClick={this.volver.bind(this)}>Cancelar</a>
							<a onClick={this.eliminar.bind(this)} className="orange-btn">Eliminar</a>
						</div>
					</div>
				</div>
			</div>            
		);
	}
}

export default connect(mapState, mapDispatch)(GestionarEliminar);


// WEBPACK FOOTER //
// ./src/acceso-familiar/GestionarEliminar.cmpt.js